export default {
    ML2: 'ml2',
    OPENCREDIT: 'opencredit',
    ROBO: 'robo',
    GDPR_DRF: 'gdprDRF',
    CAPTCHA: 'captcha',
    HCAPTCHA: 'hCaptcha',

    VIDEOCALLS_IN_1_BOX: 'videos',
    TC_VIDEOS: 'tcVideos',
    ROBO_VIDEOS: 'roboVideos',

    VIDEOCALL: 'videoCall',
    TC_VIDEOCALL: 'tcVideollamada',
    ROBO_VIDEOCALL: 'roboVideoCall',

    VIDEOSELFIE: 'videoSelfie',
    TC_VIDEOSELFIE: 'tcVideoselfie',
    ROBO_VIDEOSELFIE: 'roboVideoSelfie',

    ONLINE_IBAN: 'ibanOnline',
    IBANTRANSFER: 'iban',
    TC_IBAN: 'tcIban',
    ROBO_IBAN: 'roboIban',

    NORMALTRANSFER: 'transfer',
    ROBO_TRANSFER: 'roboTransfer',

    PHYSICALIDEN: 'physicalIden',
    COURIER: 'courier',
    STREET_LETTER: 'streetLetter',
    MAPS_SEARCH: 'mapsSearch',
    LASTNAME_DISCLAIMER: 'lastNameDisclaimer',
    VIDEO_CALL_CHROME_IOS_FLAG: 'videoCallChromeIos',
    VIDEO_SELFIE_CHROME_IOS_FLAG: 'videoSelfieChromeIos',

    ACTIVATE_NEW_LOGIN: 'activateNewLogin',
    DISPLAY_LOGIN_LINK: 'tcDisplayLoginLink',

    NEW_OPTIONS_OPERATIONS: 'newOptionsOperationsFiocEnabled',
    MODEL_BANK_REDIRECTION_ONBOARDING: 'mbLoginRedirection',
    SIGNATURE_KEY_ENABLED: 'signatureKeyEnabled',

    CALL_ME_BACK: 'buttonCmbEnabled',
    TRANSFER_MVP_STEP: 'transfermvpstep',
    ACTIVITY_DATA_TGSS: 'activityDataTgss',
    FIOC_TGSS: 'employmentHistoryTgss',
    ONBOARDING_FLAG_WEB_FIOC_RESPONSE_NO_ACT: 'fiocResponseNoAct',
    OTP_STEP_ACTIVE: 'traditionalIbanTransferOtp',

    SINGLE_IDENTIFICATION_METHOD_PAGE: 'singleIdentificationMethodPage',
    VIDEOSELFIE_BIOMETRY_DECISION: 'videoselfieBiometryDecision',
    VIDEOSELFIE_CAPTURE: 'videoselfieCapture',

    DOCUMENTATION_NOTICE_MOBILE: 'documentUploadWarningComponentMobile',
    DOCUMENTATION_NOTICE_DESKTOP: 'documentUploadWarningComponentWeb',
};
